import { useMemo, useState } from 'react';
import { Share2 } from 'lucide-react';
import { useStreak, useTrainingRecords } from '@/hooks/useAppState';
import { getExerciseById } from '@/data/exercises';
import { isTrainingRecordComplete } from '@/lib/trainingRecordCompletion';
import WorkoutShareDialog from './WorkoutShareDialog';
import { buildWorkoutShareData, latestShareRecord } from './workoutShareData';

export default function HomeShareButton() {
  const [open, setOpen] = useState(false);
  const { records, prRecords } = useTrainingRecords();
  const { streak } = useStreak();
  const data = useMemo(() => {
    const record = latestShareRecord(records);
    return record ? buildWorkoutShareData({ exercises: record.exercises, durationMin: record.durationMin,
      getExercise: getExerciseById, date: record.date, dayName: record.dayName,
      completed: isTrainingRecordComplete(record), streakDays: streak,
      newPRs: prRecords.filter(pr => pr.recordId === record.id),
    }) : undefined;
  }, [records, prRecords, streak]);
  return <>
    <button type="button" aria-label="分享练刻" title="分享练刻" aria-haspopup="dialog" onClick={() => setOpen(true)} className="home-share-entry"><Share2 size={18} aria-hidden="true"/></button>
    {open && <WorkoutShareDialog data={data} onClose={() => setOpen(false)}/>}
  </>;
}
